//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { getTikTokMentionsFeatureEnabled } from '@publishing/analytics/selectors/getTikTokMentionsFeaturesEnabled';
import { getRequiredPermissions } from '@tiktok/tiktokConstants';

export const getTikTokAccountSettings = (state: ICuralateStore) =>
  state.accountSettings.socialMedia.tiktok;

export const getTikTokAccountSettingsFlags = createSelector(
  getTikTokAccountSettings,
  (accountSettings) => accountSettings.flags,
);

export const getHasRequiredTikTokApiPermissions = createSelector(
  getTikTokAccountSettings,
  getTikTokMentionsFeatureEnabled,
  (accountSettings, getIsTikTokMentionsFeatureEnabled) => {
    const tiktokScope = accountSettings.connectedAccount?.scope ?? [];

    // TODO: PD-285704: Remove this once tiktok mentions ingestion feature flag is released
    const requiredPermissions = getRequiredPermissions(
      getIsTikTokMentionsFeatureEnabled,
    );

    return requiredPermissions.every((permission) =>
      tiktokScope.includes(permission),
    );
  },
);

export const getIsTikTokAccountReconnecting = createSelector(
  getTikTokAccountSettingsFlags,
  (accountSettingsFlags) => accountSettingsFlags.isReconnecting,
);

export const getIsTikTokLoading = createSelector(
  getTikTokAccountSettingsFlags,
  getIsTikTokAccountReconnecting,
  (
    { isConnecting, isDisconnecting, isFetchingOAuthUrl, isFetchingSettings },
    isTikTokAccountReconnecting,
  ) =>
    isTikTokAccountReconnecting ||
    isFetchingSettings ||
    isConnecting ||
    isFetchingOAuthUrl ||
    isDisconnecting,
);
